import api from "@/api/api-config";
import axios from "axios";
import jwt_decode from "jwt-decode";

const key = "token";

export async function loginUserAxios(login) {
  const { data } = await axios.post(login.tokenEndpoint, login.eiamLoginParams, {
    headers: { "content-type": "application/x-www-form-urlencoded" },
  });
  // Tokendaten auslesen
  const idTokenPayload = jwt_decode(data.id_token);
  const accessTokenPayload = jwt_decode(data.access_token);
  let isIdTokenValid;
  let isAccessTokenValid;
  // Die Tokens, welche zurückgesendet werden
  let tokens = {
    internalToken: "",
    accessToken: "",
    valid: false
  }
  // Verifizieren, ob die Daten in den Token vertrauenswürdig sind
  try {
    isIdTokenValid = await validateUserData(data.id_token, idTokenPayload);
  } catch (e) {}
  try {
    isAccessTokenValid = await validateUserData(data.access_token, accessTokenPayload);
  } catch (e) {}
  // Diesen brauchen wir sowieso. Egal ob wir ein Login auf unsere Applikation wollen
  // oder beim eIAM gleich wieder ausloggen
  sessionStorage.setItem("id_token", data.id_token);
  // Wenn die Token vertrauenswürdige Daten haben, dann Login einleiten...
  if (isIdTokenValid.data === true && isAccessTokenValid.data === true) {
    const tokenRefreshOffsetInMs = 10000;
    const tokenExpTimeInSec = idTokenPayload.exp;
    const tokenExpTimeInMs = tokenExpTimeInSec * 1000;
    sessionStorage.setItem("tokenExpTime", tokenExpTimeInMs);
    sessionStorage.setItem("tokenRefreshTime", tokenExpTimeInMs - tokenRefreshOffsetInMs);
    sessionStorage.setItem("refreshToken", data.refresh_token);
    sessionStorage.setItem("validityDuration", data.expires_in);
    const internalToken = await api.post("Login", { oidctoken: data.id_token });
    tokens = {
      internalToken: internalToken.data,
      accessToken: data.access_token,
      valid: true
    }
  }
  // Wenn die Token nicht vertrauenswürdig sind, dann die leeren Strings zurücksenden und somit ausloggen.
  return tokens;
}

export async function validateUserData(token, userdata) {
  return await api
  .post("Login/BenutzerAnfrage/Create", {
    // Dummy Properties zum verwirren von hier ...
    UserExtId: userdata.sub.slice(userdata.sub.lastIndexOf("\\") + 1),
    Vorname: userdata.given_name,
    Nachname: userdata.family_name,
    Email: userdata.email,
    Sprache: userdata.language,
    AntragId: 1,
    // ... bis hier
    Token: token,
    CheckOnly: true
  });
}

export function getToken() {
  return sessionStorage.getItem(key);
}

export function getTokenExpireTime(tokenPayload) {
  if (tokenPayload) {
    let expireTimeInSec = tokenPayload.exp;
    let expireTimeInMs = expireTimeInSec * 1000;
    return expireTimeInMs;
  }
}

export async function tokenRefresh(refreshProps) {
  return await axios.post(refreshProps.tokenEndpoint, refreshProps.eiamLoginParams, {
    headers: { "content-type": "application/x-www-form-urlencoded" },
  });
}

export function logOut() {
  // Unklar ob diese Funktion noch aufgerufen wird / wegweg??
  sessionStorage.clear();
}
